import React, { useEffect, useRef, useState } from 'react';
import FloatingBox from './FloatingBox';
import { servicesBoxes } from '../constants/data';
import { servicesGradient } from '../constants/assets';

export default function ServicesSection() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [visibleCount, setVisibleCount] = useState(0);
  const [firstBox, secondBox] = servicesBoxes;

  if (!firstBox || !secondBox) {
    return null;
  }

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          observer.disconnect();
          setVisibleCount(1);
          setTimeout(() => setVisibleCount(2), 420);
        }
      },
      { threshold: 0.15 }
    );

    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" className="flex flex-col-reverse lg:flex-row items-center justify-center gap-12 px-8 py-4 w-full" ref={containerRef}>
      {/* Floating info boxes — stacked with offset */}
      <div className="services-floating-stack relative shrink-0">
        <FloatingBox
          {...firstBox}
          theme="light"
          visible={visibleCount >= 1}
          className="services-box-1"
        />
        <FloatingBox
          {...secondBox}
          theme="light"
          visible={visibleCount >= 2}
          className="services-box-2"
        />
      </div>

      <div className="services-gradient-pill relative shrink-0 bg-no-repeat bg-cover bg-[url(./assets/services-night-sky.webp)]">
        <div className="services-gradient-content absolute flex flex-col gap-4 items-start text-white">
          <p className="font-trispace type-section-label">Services</p>
          <h2 className="font-trispace type-h1 w-full">How we build, and why it works.</h2>
          <p className="font-trispace type-body1 w-full">
            Everything is connected. The tools, the data, the people. We build at the intersection of
            deep expertise and intelligent automation — not to cut corners, but to build better.
          </p>
        </div>
      </div>
    </section>
  );
}
